export const MAX_VOICE_BYTES = 6 * 1024 * 1024;
export const VOICE_RECORDING_SECONDS = 180;
export const VOICE_DECODED_SECONDS = 181;
export const VOICE_FORMATS = ['audio/webm', 'audio/mp4', 'audio/ogg', 'audio/wav'];
export const VOICE_TIMEOUT_MS = 600_000;
/** Push-to-talk presses shorter than this are treated as accidental and discarded. */
export const PUSH_TO_TALK_MIN_SECONDS = 0.4;
